import { Component, Input, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { DeliveryNote } from '../../../delivery-notes.models';
import { DeliveryNotesService } from '../../../delivery-notes.service';

@Component({
    selector: 'app-delivery-notes-overview-table-default',
    templateUrl: './delivery-notes-overview-table-default.component.html',
    standalone: false
})
export class DeliveryNotesOverviewTableDefaultComponent implements OnInit {
  @Input() deliveryNotes: DeliveryNote[];
  @Input() marketplace: Boolean = false;

  constructor(
    protected routing: RoutingService,
    private deliveryNotesService: DeliveryNotesService
  ) { }

  ngOnInit(): void { }

  openTracking(deliveryNote: DeliveryNote): void {
    const url = deliveryNote?.trackingUrl;
    window.open(url);
  }

  openPdf(pdfUrl: string): void {
    this.deliveryNotesService.getPdf(pdfUrl);
  }

  goToDeliveryNoteDetail(deliveryNote: DeliveryNote): void {
    if (this.marketplace) {
      this.routing.go({
        cxRoute: 'marketplaceDeliveryNoteDetails',
        params: deliveryNote
      });
    }
    else {
      this.routing.go({
        cxRoute: 'deliveryNoteDetails',
        params: deliveryNote
      });
    }

  }
}
